// extracted by mini-css-extract-plugin
module.exports = {"slide":"DetailEditMemberLevel_slide_2vA3h","slide-reverse":"DetailEditMemberLevel_slide-reverse_ipR9z","detailEditMemberLevel":"DetailEditMemberLevel_detailEditMemberLevel_NTTXN"};